/*
interface SISTEMA_PERMISSOES_INTERFACE {
  [key: string]: {
    MODULO: string
    PERMISSOES: {
      [key: string]: string
      // EXCLUIR: string,

    }
  }
}
*/


// TODO - Criar Novo Crud
export interface SISTEMA_PERMISSOES_INTERFACE {

  /*
  PARAMETRO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }
*/

  CLIENTES: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  IMPORTACAO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  GRUPOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  USUARIOS: {
    MODULO: string
    PERMISSOES: {
      USUARIOS_GLOBAIS: string
      CADASTRO_USUARIO_CLIENTE: string
    }
  }

}

export const SISTEMA_PERMISSOES: SISTEMA_PERMISSOES_INTERFACE = {

  /*
  PARAMETRO: {
    MODULO: 'Parâmetros Gerais do Sistema',
    PERMISSOES: {
      MANUTENCAO: 'Aleração dos Parâmetros'
    }
  },
  */

  CLIENTES: {
    MODULO: 'Cadastro de Clientes',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Clientes'
    }
  },

  IMPORTACAO: {
    MODULO: 'Importação de Dados',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Importação'
    }
  },

  GRUPOS: {
    MODULO: 'Cadastro de Grupos de Usuários',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Grupos'
    }
  },

  USUARIOS: {
    MODULO: 'Cadastro de Usuário',
    PERMISSOES: {
      USUARIOS_GLOBAIS: 'Manutenção de Usuários Globais',
      CADASTRO_USUARIO_CLIENTE: 'Manutenção de Usuários de Clientes'
    }
  }

}
